import {
  GENDER_TYPES,
  MARITAL_STATUS,
  VISA_TYPES_SLUGS,
} from "../../utils/enums";

import { ApplicationById } from "../../types/General";
import moment from "moment";
import { Button } from "@mui/material";

type props = {
  type: any;
  data?: ApplicationById | null;
};
const ApplicationDetail = ({ type, data }: props) => {
  return (
    <>
      <div className="profileInfo_list">
        <ul className="text_info gap_p">
          <li className="w_50">
            <strong>Visa Type</strong>
            <span>
              {type === VISA_TYPES_SLUGS.TOURIST_VISA
                ? "Visit Visa"
                : type === VISA_TYPES_SLUGS.BUSINESS_VISA
                  ? "Business Visa"
                  : type === VISA_TYPES_SLUGS.WORK_VISA
                    ? "Work Visa"
                    : "Study Visa"}
            </span>
          </li>
          <li className="w_50">
            <strong>Applicant Name</strong>
            <span>
              {`${data?.first_name} ${data?.middle_name || ""} ${data?.last_name}`}
            </span>
          </li>
          <li className="w_50">
            <strong>Applicant Email</strong>
            <span>{data?.email || ""}</span>
          </li>
          <li className="w_50">
            <strong>Applicant Phone Number</strong>
            <span>
              {data?.phone_no
                ? `${data?.country_code ? data?.country_code : ""} ${data?.phone_no}`
                : ""}
            </span>
          </li>
          <li className="w_50">
            <strong>DOB</strong>
            <span>{data?.birthdate || ""}</span>
          </li>
          <li className="w_50">
            <strong>Civil Status</strong>
            <span>{MARITAL_STATUS[data?.martial_status]}</span>
          </li>
          <li className="w_50">
            <strong>Passport Number</strong>
            <span>{data?.passport || ""}</span>
          </li>
          <li className="w_50">
            <strong>Issue Date</strong>
            <span>{data?.passport_issued_date || ""}</span>
          </li>
          <li className="w_50">
            <strong>Expiry Date</strong>
            <span>{data?.passport_expiry_date || ""}</span>
          </li>
          <li className="w_50">
            <strong>Place of Birth</strong>
            <span>{data?.place_of_birth || ""}</span>
          </li>

          <li className="w_50">
            <strong>Home Address</strong>
            <span>{data?.address || ""}</span>
          </li>

          <li className="w_50">
            <strong>Home City</strong>
            <span>{data?.city || ""}</span>
          </li>
          <li className="w_50">
            <strong>Home State</strong>
            <span>{data?.state || ""}</span>
          </li>
          <li className="w_50">
            <strong>Home Country</strong>
            <span>{data?.address_country || ""}</span>
          </li>

          <li className="w_50">
            <strong>Home Postal Code</strong>
            <span>{data?.pin_code || ""}</span>
          </li>
          <li className="w_50">
            <strong>Residential Address</strong>
            <span>{data?.residence_address || ""}</span>
          </li>
          <li className="w_50">
            <strong>Residential City</strong>
            <span>{data?.residence_city || ""}</span>
          </li>
          <li className="w_50">
            <strong>Residential State</strong>
            <span>{data?.residence_state || ""}</span>
          </li>
          <li className="w_50">
            <strong>Residential Country</strong>
            <span>{data?.residence_country || ""}</span>
          </li>

          <li className="w_50">
            <strong>Residential Postal Code</strong>
            <span>{data?.residence_pin_code || ""}</span>
          </li>
          <li className="w_50">
            <strong>Residence Mobile Number</strong>
            <span>{data?.residence_phone_no || ""}</span>
          </li>
          <li className="w_50">
            <strong>Residence Id</strong>
            <span>{data?.residence_id || ""}</span>
          </li>
          <li className="w_50">
            <strong>Visa Expiry</strong>
            <span>{data?.visa_expiry_date || ""}</span>
          </li>
          <li className="w_50">
            <strong>Current Job Profession</strong>
            <span>{data?.current_job || ""}</span>
          </li>
          <li className="w_50">
            <strong>Work Place Address</strong>
            <span>{data?.work_address || ""}</span>
          </li>
          <li className="w_50">
            <strong>Work State</strong>
            <span>{data?.work_state || ""}</span>
          </li>
          <li className="w_50">
            <strong>Work City</strong>
            <span>{data?.work_city || ""}</span>
          </li>

          <li className="w_50">
            <strong>Work Postal Code</strong>
            <span>{data?.work_pin_code || ""}</span>
          </li>
          <li className="w_50">
            <strong>Company Name</strong>
            <span>{data?.work_company_name || ""}</span>
          </li>
          <li className="w_50">
            <strong>Employer Phone Number</strong>
            <span>
              {" "}
              {data?.work_company_phone_no
                ? `${data?.work_company_country_code ? data?.work_company_country_code : ""} ${data?.work_company_phone_no}`
                : ""}
            </span>
          </li>
          <li className="w_50">
            <strong>Employer Email</strong>
            <span>{data?.work_company_email || ""}</span>
          </li>
          <li className="w_50">
            <strong>Applied Position</strong>
            <span>{data?.applied_position || ""}</span>
          </li>
          <li className="w_50">
            <strong>Country of Birth</strong>
            <span>{data?.country_of_birth || ""}</span>
          </li>
          <li className="w_50">
            <strong>Gender</strong>
            <span>{GENDER_TYPES[Number(data?.gender)] || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Religion</strong>
            <span>{data?.religion || " "}</span>
          </li>
          <li className="w_50">
            <strong>Citizenship</strong>
            <span>{data?.citizenship || ""}</span>
          </li>

          <li className="w_50">
            <strong>Country of Residence</strong>
            <span>{data?.country_of_residence || ""}</span>
          </li>
          <li className="w_50">
            <strong>Date</strong>
            <span>
              {data?.created_at
                ? moment(data?.created_at).format("DD MMM YYYY")
                : "-"}
            </span>
          </li>
          {type === VISA_TYPES_SLUGS.STUDY_VISA ? (
            <>
              <li className="w_50">
                <strong>Course Name</strong>
                <span>{data?.course_of_study || "-"}</span>
              </li>
              <li className="w_50">
                <strong>School Leaving Certificate Issuing Country</strong>
                <span>{data?.school_cert_country?.name || "-"}</span>
              </li>
              <li className="w_50">
                <strong>School Leaving Certificate Name</strong>
                <span>{data?.school_cert_name || "-"}</span>
              </li>
              <li className="w_50">
                <strong>School Name</strong>
                <span>{data?.school_name || "-"}</span>
              </li>
              <li className="w_50">
                <strong>School Address</strong>
                <span>{data?.school_address || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Participation in State Examination</strong>
                <span>{data?.state_exam_participation ? "Yes" : "No"}</span>
              </li>
              {data?.state_exam_participation ? (
                <>
                  <li className="w_50">
                    <strong>State Examination Date</strong>
                    <span>{data?.state_exam_date || "-"}</span>
                  </li>
                  <li className="w_50">
                    <strong>State Examination Marks</strong>
                    <span>{data?.state_exam_score || "-"}</span>
                  </li>
                </>
              ) : null}
              <li className="w_50">
                <strong>University Name</strong>
                <span>{data?.university_name || "-"}</span>
              </li>
              <li className="w_50">
                <strong>University Address</strong>
                <span>{data?.university_address || "-"}</span>
              </li>
              <li className="w_50">
                <strong>Languages</strong>
                <span>
                  {Array.isArray(data?.language)
                    ? data.language.join(", ")
                    : data?.language || "-"}
                </span>
              </li>
            </>
          ) : null}

          {data?.employment_letter?.length ? (
            <li className="w_50" style={{ alignItems: "center" }}>
              <strong>Offer Letter </strong>
              <span>
                <Button
                  variant="contained"
                  onClick={() =>
                    window?.open(data?.employment_letter?.[0]?.media_url)
                  }
                >
                  Download
                </Button>
              </span>
            </li>
          ) : null}
          {data?.work_permit?.length ? (
            <li className="w_50" style={{ alignItems: "center" }}>
              <strong>Work Permit</strong>
              <span>
                <Button
                  variant="contained"
                  onClick={() =>
                    window?.open(data?.work_permit?.[0]?.media_url)
                  }
                >
                  Download
                </Button>
              </span>
            </li>
          ) : null}

          {data?.reject_reason ? (
            <li
              className="w_100"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <strong>Rejection Reason</strong>
              <span>{data?.reject_reason || "-"}</span>
            </li>
          ) : null}
        </ul>
      </div>
      <h2 style={{ margin: "30px 0 20px" }}>Questions</h2>
      {data?.questions && data?.questions.length > 0 ? (
        <div className="profileInfo_list">
          <ul className="text_info gap_p">
            {data?.questions.map((item: any, index: number) => (
              <li key={index} className="w_100">
                <strong>{item?.question}</strong>
                <span>{item?.answer_display}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p>No Questions Found</p>
      )}
    </>
  );
};

export default ApplicationDetail;
